<template>
  <div v-if="modelValue" class="confirm-mask" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" @click.self="cancel">
    <div class="confirm-dialog" @click.stop>
      <h2 id="confirm-title" class="confirm-title">{{ title }}</h2>
      <p class="confirm-message">{{ message }}</p>
      <label v-if="showCheckbox" class="confirm-checkbox checkbox-label">
        <input v-model="checkboxChecked" type="checkbox" :disabled="confirmLoading" />
        {{ checkboxLabel }}
      </label>
      <div class="confirm-actions">
        <button type="button" class="btn btn-secondary" @click="cancel">
          {{ cancelLabel }}
        </button>
        <button
          type="button"
          class="btn btn-danger"
          :disabled="confirmLoading"
          @click="confirm"
        >
          <span v-if="confirmLoading" class="confirm-loading">
            <i class="material-icons spin">sync</i>
            {{ confirmLoadingLabel }}
          </span>
          <span v-else>{{ confirmLabel }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: 'Confirmar' },
    message: { type: String, default: 'Tem certeza?' },
    confirmLabel: { type: String, default: 'Excluir' },
    cancelLabel: { type: String, default: 'Cancelar' },
    confirmLoading: { type: Boolean, default: false },
    confirmLoadingLabel: { type: String, default: 'Excluindo...' },
    showCheckbox: { type: Boolean, default: false },
    checkboxLabel: { type: String, default: '' },
    checkboxDefault: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'confirm'],
  data() {
    return {
      checkboxChecked: false,
    };
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.checkboxChecked = this.checkboxDefault;
      }
    },
  },
  methods: {
    cancel() {
      if (!this.confirmLoading) {
        this.$emit('update:modelValue', false);
      }
    },
    confirm() {
      if (this.confirmLoading) return;
      this.$emit('confirm', this.showCheckbox ? { checkboxChecked: this.checkboxChecked } : undefined);
      // Parent closes dialog after async action (e.g. delete) completes
    },
  },
};
</script>

<style scoped>
.confirm-mask {
  position: fixed;
  z-index: 10000;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
}

.confirm-dialog {
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: var(--space-lg);
  max-width: 360px;
  width: 100%;
}

.confirm-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 var(--space-sm);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.confirm-message {
  font-size: 0.95rem;
  color: var(--color-text-secondary);
  margin: 0 0 var(--space-lg);
  line-height: 1.5;
}

.confirm-checkbox {
  display: flex;
  align-items: flex-start;
  gap: var(--space-sm);
  margin: 0 0 var(--space-lg);
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  user-select: none;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-sm);
}

.confirm-loading {
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
}

.confirm-loading .material-icons.spin {
  animation: confirm-spin 1s linear infinite;
}

@keyframes confirm-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
